import {Routes} from '@angular/router';
import {LoginLayoutComponent} from './login-layout.component';
import {EnterPasswordComponent} from './enter-password/enter-password.component';
import {EmailPasswordComponent} from './email-password/email-password.component';

export const LoginRoutes: Routes = [
  {
    path: '', component: LoginLayoutComponent, children: [
      {path: '', redirectTo: 'sign-in', pathMatch: 'full'},
      {path: 'sign-in', component: EmailPasswordComponent},
      {path: 'enter-password/:userId/:name', component: EnterPasswordComponent}
    ]
  }
];
